import { useListDataRoomNodesForLp } from "@vega-api/generated/deal-opportunity-data-room-lp-view/deal-opportunity-data-room-lp-view";
import type { DataRoomNodeView } from "@vega-api/generated/types/dataRoomNodeView";

export type DataRoomTreeNode = DataRoomNodeView & {
  children: DataRoomTreeNode[];
};

function compareNodes(a: DataRoomTreeNode, b: DataRoomTreeNode): number {
  if (a.isFolder !== b.isFolder) return a.isFolder ? -1 : 1;

  return a.name.localeCompare(b.name);
}

function buildTree(nodes: DataRoomNodeView[]): DataRoomTreeNode[] {
  const nodeMap = new Map<string, DataRoomTreeNode>();
  const roots: DataRoomTreeNode[] = [];

  for (const node of nodes) {
    nodeMap.set(node.id, { ...node, children: [] });
  }

  for (const node of nodes) {
    const treeNode = nodeMap.get(node.id)!;
    const parentId = node.parentId;

    if (!parentId) {
      roots.push(treeNode);
      continue;
    }

    const parent = nodeMap.get(parentId);

    if (parent) {
      parent.children.push(treeNode);
    } else {
      roots.push(treeNode);
    }
  }

  nodeMap.forEach((node) => {
    node.children = node.children.toSorted(compareNodes);
  });

  return roots.toSorted(compareNodes);
}

export function useLpDataRoom(
  dealOpportunityId: string,
  dataRoomId: string | undefined,
) {
  const {
    data: rootNodes,
    isLoading,
    isError,
  } = useListDataRoomNodesForLp(dealOpportunityId, dataRoomId ?? "", {
    query: {
      enabled: !!dataRoomId,
      select: (response) => buildTree(response.data.nodes),
    },
  });

  return {
    rootNodes: rootNodes ?? [],
    isLoading,
    isError,
  };
}
